import {loggers} from "atom";

const {makeLogger} = loggers;

export default container => {
    container.declare("logger", () => {
        return makeLogger();
    });
};
